<template>
  <div class="popup-container">
    <DxPopup
      :visible="isVisible"
      :height="325"
      title="Bank Transfer"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
      @shown="initialise"
    >
      <div class="css-v2 gc-popup-form">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getFormItems"
          :formHeight="200"
          :isNormal="true"
          :data-model="newBankTransferModel"
          :formMode="'create'"
          :validationGroup="'gcPopupConfig-gc-popup-form-data-gc-popup-bank-transfer'"
          :formTitle="'gc-popup'"
          :ref="'bank-transfer-modal'"
        ></gc-form>
      </div>

      <div class="footer-buttons">
        <DxButton
          text="Save"
          type="success"
          styling-mode="contained"
          class="button-full-width margin-left-5"
          @click="saveBankTransfer"
        />
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="button-full-width margin-right-5"
          @click="cancelBankTransfer"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { BankAccountsServices } from "../_services/api/finance/bankAccounts";
import { CompanyCurrencyService } from "../_services/api/accounts/company-currency.service";
import { CompanyService } from "../_services/api/accounts/company.service";
import { BankTransferService } from "../_services/api/finance/bank-transfer.service";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    callback: {
      type: Function,
      default: function () {},
    },
    showValidationSummary: {
      type: Function,
      default: function () {},
    },
    setLoading: {
      type: Function,
      default: function () {},
    },
  },
  data() {
    return {
      newBankTransferModel: {
        AmountFrom: 0,
        AmountTo: 0,
        Amount: 0,
        FromBank: undefined,
        FromBankCurrency: undefined,
        ToBank: undefined,
        ToBankCurrency: undefined,
        ExchangeRate: 0,
        Comments: undefined,
        Date: new Date(),
      },
      BankListDataSource: [],
      BaseCurrency: undefined,
      CompanyCode: undefined,
      validationSummary: [],
    };
  },
  methods: {
    async initialise() {
      this.setLoading(true);
      this.newBankTransferModel = {
        AmountFrom: 0,
        AmountTo: 0,
        Amount: 0,
        FromBank: undefined,
        FromBankCurrency: undefined,
        ToBank: undefined,
        ToBankCurrency: undefined,
        ExchangeRate: 0,
        Comments: undefined,
        Date: new Date(),
      };

      await BankAccountsServices.getCustomData({
        url: "BankRecord",
        filter: "Inactive eq 'N'",
        orderby: "AccountName asc",
      })
        .then((BankRecordResponse) => {
          this.BankListDataSource = BankRecordResponse.data.value;
        })
        .catch(() => {
          this.setLoading(false);
        });

      await CompanyService.getCompany()
        .then((res) => {
          let companyDetails = res.data.value[0];
          if (companyDetails) {
            this.BaseCurrency = companyDetails.CurrencyCode;
            this.CompanyCode = companyDetails.Code;
          }
        })
        .catch(() => {
          this.setLoading(false);
        });
      this.setLoading(false);
    },
    validateForm() {
      this.validationSummary = [];
      if (this.newBankTransferModel.AmountTo <= 0) {
        this.validationSummary.push({
          message: "Amount To must be greater than 0.",
        });
      }
      if (this.newBankTransferModel.AmountFrom <= 0) {
        this.validationSummary.push({
          message: "Amount From must be greater than 0.",
        });
      }
      if (this.newBankTransferModel.ExchangeRate <= 0) {
        this.validationSummary.push({
          message: "Exchange Rate must be greater than 0.",
        });
      }
      if (!this.newBankTransferModel.ToBank) {
        this.validationSummary.push({ message: "To Bank must be selected." });
      }
      if (!this.newBankTransferModel.FromBank) {
        this.validationSummary.push({ message: "From Bank must be selected." });
      }
    },
    async saveBankTransfer() {
      this.validateForm();
      if (this.validationSummary.length > 0) {
        this.showValidationSummary(this.validationSummary);
        return;
      }
      let confirmSaving = await this.$confirm(
        "Do you want to continue with this bank transfer?",
        "Bank Transfer Confirmation"
      );
      if (!confirmSaving) return;

      let payload = {
        SourceBankAccount: this.newBankTransferModel.FromBank,
        DestinationBankAccount: this.newBankTransferModel.ToBank,
        TransferAmount: this.newBankTransferModel.Amount,
        FXTransferAmount: this.getFXTransferAmount(),
        ExchangeRate: this.newBankTransferModel.ExchangeRate,
        Comment: this.newBankTransferModel.Comments,
        TransferDate: new Date(this.newBankTransferModel.Date).toSaveDate(),
      };

      this.setLoading(true);
      await BankTransferService.saveBankTransferService(payload)
        .then((res) => {
          this.setLoading(false);
          this.$notify(
            `Bank Transfer #${res.data.BankTransferCode} has been successfully created resulting in Sundry Payment #${res.data.SundryPaymentCode} and Sundry Receipt #${res.data.SundryReceiptCode} being created for the respective bank accounts.`,
            "success"
          );
        })
        .catch((err) => {
          this.setLoading(false);
          this.serverError = {
            err: err,
            msg: "Save Failed.",
            time: new Date().getTime(),
          };
        });
      this.callback(true);
    },
    cancelBankTransfer() {
      this.callback();
    },
    calculateExchangeRate() {
      if (this.toAndFromBankAccountsAreBaseCurrency)
        this.newBankTransferModel.ExchangeRate = 1.0;

      if (this.newBankTransferModel.FromBankCurrency != this.BaseCurrency) {
        CompanyCurrencyService.getByCompanyCodeAndCurrencyCode(
          this.CompanyCode,
          this.newBankTransferModel.FromBankCurrency
        ).then((res) => {
          if (res.data.value.length > 0) {
            this.newBankTransferModel.ExchangeRate = res.data.value[0].SellRate;
          }
        });
      } else {
        CompanyCurrencyService.getByCompanyCodeAndCurrencyCode(
          this.CompanyCode,
          this.newBankTransferModel.ToBankCurrency
        ).then((res) => {
          if (res.data.value.length > 0) {
            this.newBankTransferModel.ExchangeRate = res.data.value[0].BuyRate;
          }
        });
      }
    },
    calculateAmountTo() {
      if (!this.newBankTransferModel.ExchangeRate) {
        this.newBankTransferModel.AmountTo = 0.0;
      } else if (this.isFromBankCurrencyTheSameAsToBankCurrency) {
        this.newBankTransferModel.AmountTo =
          this.newBankTransferModel.AmountFrom;
      } else if (
        this.newBankTransferModel.FromBankCurrency == this.BaseCurrency
      ) {
        this.newBankTransferModel.AmountTo =
          this.newBankTransferModel.AmountFrom *
          this.newBankTransferModel.ExchangeRate;
      } else {
        this.newBankTransferModel.AmountTo =
          this.newBankTransferModel.AmountFrom /
          this.newBankTransferModel.ExchangeRate;
      }
    },
    calculateBookImpact() {
      if (!this.newBankTransferModel.ExchangeRate) {
        this.newBankTransferModel.Amount = 0.0;
      } else if (
        this.newBankTransferModel.ToBankCurrency == this.BaseCurrency
      ) {
        this.newBankTransferModel.Amount = this.newBankTransferModel.AmountTo;
      } else if (
        this.newBankTransferModel.FromBankCurrency == this.BaseCurrency
      ) {
        this.newBankTransferModel.Amount = this.newBankTransferModel.AmountFrom;
      } else {
        this.newBankTransferModel.Amount =
          this.newBankTransferModel.AmountFrom /
          this.newBankTransferModel.ExchangeRate;
      }
    },
    fromBankSelected(e) {
      let bankDetails = this.BankListDataSource.find((x) => x.Code == e.value);
      if (bankDetails == undefined) {
        this.newBankTransferModel.FromBankCurrency = undefined;
      } else {
        this.newBankTransferModel.FromBankCurrency = bankDetails.CurrencyCode;
      }
      if (this.newBankTransferModel.ToBank) {
        this.calculateExchangeRate();
        this.calculateAmountTo();
        this.calculateBookImpact();
      }
    },
    toBankSelected(e) {
      let bankDetails = this.BankListDataSource.find((x) => x.Code == e.value);
      if (bankDetails == undefined) {
        this.newBankTransferModel.ToBankCurrency == undefined;
      } else {
        this.newBankTransferModel.ToBankCurrency = bankDetails.CurrencyCode;
      }
      if (this.newBankTransferModel.FromBank) {
        this.calculateExchangeRate();
        this.calculateAmountTo();
        this.calculateBookImpact();
      }
    },
    fromAmountChanged() {
      this.calculateAmountTo();
      this.calculateBookImpact();
    },
    exchangeRateChanged(e) {
      if (e.value <= 0) {
        this.newBankTransferModel.ExchangeRate = e.previousValue;
      } else {
        this.calculateAmountTo();
        this.calculateBookImpact();
      }
    },
    getFXTransferAmount() {
      if (this.newBankTransferModel.FromBankCurrency != this.BaseCurrency) {
        return this.newBankTransferModel.AmountFrom;
      }
      return this.newBankTransferModel.AmountTo;
    },
    /*
      This returns a filtered array of selectable bank accounts.
      
      allBankAccounts: An array of all the bank accounts that will be filtered.
      currentlySelectedBankAccount: This is the bank account that has already been selected.
                                    {ComputedCode, CurrencyCode}
     */
    filterBankAccountSelectOptions(
      allBankAccounts,
      currentlySelectedBankAccount,
      baseCurrency
    ) {
      if (currentlySelectedBankAccount.ComputedCode == undefined)
        return allBankAccounts;

      if (currentlySelectedBankAccount.CurrencyCode == baseCurrency) {
        return allBankAccounts.filter(
          (account) =>
            account.ComputedCode != currentlySelectedBankAccount.ComputedCode
        );
      }

      return allBankAccounts.filter(
        (account) =>
          account.ComputedCode != currentlySelectedBankAccount.ComputedCode &&
          (account.CurrencyCode == currentlySelectedBankAccount.CurrencyCode ||
            account.CurrencyCode == baseCurrency)
      );
    },
  },
  computed: {
    isVisible() {
      return this.visible;
    },
    toAndFromBankAccountsAreBaseCurrency() {
      if (this.newBankTransferModel.ToBankCurrency == undefined) return false;
      if (this.newBankTransferModel.FromBankCurrency == undefined) return false;

      return (
        this.newBankTransferModel.ToBankCurrency == this.BaseCurrency &&
        this.newBankTransferModel.FromBankCurrency == this.BaseCurrency
      );
    },
    isFromBankCurrencyTheSameAsToBankCurrency() {
      if (this.newBankTransferModel.ToBankCurrency == undefined) return false;
      if (this.newBankTransferModel.FromBankCurrency == undefined) return false;

      return (
        this.newBankTransferModel.FromBankCurrency ==
        this.newBankTransferModel.ToBankCurrency
      );
    },
    fromBankLabel() {
      if (this.newBankTransferModel.FromBankCurrency != undefined) {
        return `From Bank (${this.newBankTransferModel.FromBankCurrency})`;
      }
      return "From Bank";
    },
    toBankLabel() {
      if (this.newBankTransferModel.ToBankCurrency != undefined) {
        return `To Bank (${this.newBankTransferModel.ToBankCurrency})`;
      }
      return "To Bank";
    },
    selectableFromBankAccounts() {
      return this.filterBankAccountSelectOptions(
        this.BankListDataSource,
        {
          CurrencyCode: this.newBankTransferModel.ToBankCurrency,
          ComputedCode: this.newBankTransferModel.ToBank,
        },
        this.BaseCurrency
      );
    },
    selectableToBankAccounts() {
      return this.filterBankAccountSelectOptions(
        this.BankListDataSource,
        {
          CurrencyCode: this.newBankTransferModel.FromBankCurrency,
          ComputedCode: this.newBankTransferModel.FromBank,
        },
        this.BaseCurrency
      );
    },
    getFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "DateIn",
                  dataField: "Date",
                  required: "true",
                  label: {
                    text: "Date",
                  },

                  editorOptions: {
                    allowUpdate: true,
                    min: this.DateInMin,
                    max: this.DateInMax,
                  },
                },
                {
                  screenField: "ExchangeRate",
                  label: {
                    text: "Exch Rate",
                  },
                  editorOptions: {
                    allowUpdate: !this.toAndFromBankAccountsAreBaseCurrency,
                    onValueChanged: this.exchangeRateChanged,
                  },
                  validationRules: [
                    {
                      type: "custom",
                      validationCallback: ({ value, rule }) => {
                        rule.message = `Exchange must be greater than 0.`;

                        return value > 0;
                      },
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "BankAccount",
                  dataField: "FromBank",
                  required: true,
                  label: {
                    text: this.fromBankLabel,
                  },
                  editorOptions: {
                    allowUpdate: true,
                    search: true,
                    onValueChanged: this.fromBankSelected,
                  },
                  dataSourceConfig: {
                    data: this.selectableFromBankAccounts,
                  },
                  itemTemplate: "Record",
                  cellTemplateRecord: {
                    primary: [
                      {
                        dataField: "AccountName",
                        position: "append",
                      },
                    ],
                    secondary: [
                      {
                        dataField: "BsbNo",
                        position: "append",
                      },
                      {
                        dataField: "AccountNo",
                        position: "append",
                      },
                    ],
                  },
                },
                {
                  screenField: "BankAccount",
                  dataField: "ToBank",
                  required: true,
                  label: {
                    text: this.toBankLabel,
                  },
                  editorOptions: {
                    allowUpdate: true,
                    onValueChanged: this.toBankSelected,
                  },

                  editorTemplate: {
                    primary: [
                      {
                        dataField: "AccountName",
                      },
                    ],
                    secondary: [
                      {
                        dataField: "Code",
                      },
                    ],
                  },
                  dataSourceConfig: {
                    data: this.selectableToBankAccounts,
                  },
                  itemTemplate: "Record",
                  cellTemplateRecord: {
                    primary: [
                      {
                        dataField: "AccountName",
                        position: "append",
                      },
                    ],
                    secondary: [
                      {
                        dataField: "BsbNo",
                        position: "append",
                      },
                      {
                        dataField: "AccountNo",
                        position: "append",
                      },
                    ],
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "FXAmount",
                  dataField: "AmountFrom",
                  label: {
                    text: this.amountFromLabel,
                  },
                  required: true,
                  editorOptions: {
                    min: 0,
                    max: 999999999,
                    allowUpdate: true,
                    readOnly:
                      !this.newBankTransferModel.ToBank ||
                      !this.newBankTransferModel.FromBank,
                    onValueChanged: this.fromAmountChanged,
                  },
                  validationRules: [
                    {
                      type: "custom",

                      validationCallback: ({ value, rule }) => {
                        rule.message = `Amount should be greater than 0`;
                        return value > 0;
                      },
                    },
                  ],
                },
                {
                  screenField: "FXAmount",
                  dataField: "AmountTo",
                  label: {
                    text: this.amountToLabel,
                  },
                  required: true,
                  editorOptions: {
                    min: 0,
                    max: 999999999,
                    allowUpdate: true,
                    readOnly: true,
                  },
                  validationRules: [
                    {
                      type: "custom",

                      validationCallback: ({ value, rule }) => {
                        rule.message = `Amount should be greater than 0`;
                        return value > 0;
                      },
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "title",
                  required: false,
                  cssClass: "non-edit-cell-textbox-field",
                  label: {
                    text: "Book Impact",
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  screenField: "FXAmount",
                  dataField: "Amount",
                  label: {
                    text: `Amount (${this.BaseCurrency})`,
                  },
                  required: true,
                  editorOptions: {
                    min: 0,
                    max: 999999999,
                    allowUpdate: false,
                    readOnly: true,
                  },
                },
                {
                  screenField: "FXAmount",
                  dataField: "Amount",
                  label: {
                    text: `Amount (${this.BaseCurrency})`,
                  },
                  required: true,
                  editorOptions: {
                    min: 0,
                    max: 999999999,
                    allowUpdate: false,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "Comments",
                  label: {
                    text: "Comment",
                  },
                  editorOptions: {
                    allowUpdate: true,
                  },
                },
              ],
            },
          ],
        },
      ];
    },
  },
};
</script>

<style>
.footer-buttons {
  display: flex;
  align-content: center;
  justify-content: center;
  gap: 0.4em;
}
</style>
